import { useCallback, useEffect, useState } from 'react';
import rubleRound from '~/assets/icons/currency_ruble_round.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { useLayoutDispatch } from '../../redux';
import { setMenuTabsDisabled } from '../../redux/slices/mainMenuSlice';
import {
	StyledContainer,
	StyledImg,
	StyledInput,
	StyledReadOnlyContainer,
} from './MoneyInput.styled';

interface IMoneyInput {
	value: number;
	onChange: (newValue: number) => void;
	placeholder?: string;
	readOnly?: boolean;
	min?: number;
	max?: number;
}

const MoneyInput: React.FC<IMoneyInput> = ({
	value,
	onChange,
	placeholder,
	readOnly = false,
	min = 0,
	max,
}) => {
	const dispatch = useLayoutDispatch();
	const [inputValue, setInputValue] = useState<number>(value || 0);

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const inputValue = event.target.value.replace(/\D/g, '');

			if (inputValue.length === 0) {
				setInputValue(0);
				onChange(0);
				return;
			}

			if (min && parseInt(inputValue) < min) {
				setInputValue(min);
				onChange(min);
				return;
			}
			if (max && parseInt(inputValue) > max) {
				setInputValue(max);
				onChange(max);
				return;
			}
			setInputValue(parseInt(inputValue));
			onChange(parseInt(inputValue));
		},
		[min, max],
	);

	useEffect(() => {
		setTimeout(() => {
			setInputValue(value);
		}, 50);
	}, [value]);

	if (readOnly) {
		return (
			<StyledContainer>
				<StyledReadOnlyContainer>
					<Text style={{ opacity: value ? 1 : 0.25 }}>
						{value ? value.toLocaleString('ru-RU') : placeholder}
					</Text>
				</StyledReadOnlyContainer>
				<StyledImg src={rubleRound} />
			</StyledContainer>
		);
	}

	return (
		<StyledContainer onMouseEnter={() => playSound(Sound.LinkCursor)}>
			<StyledInput
				value={inputValue ? inputValue.toLocaleString('ru-RU') : ''}
				onChange={handleChange}
				placeholder={placeholder}
				readOnly={readOnly}
				$readOnly={readOnly}
				onFocus={() => dispatch(setMenuTabsDisabled(true))}
				onBlur={() => dispatch(setMenuTabsDisabled(false))}
			/>
			<StyledImg src={rubleRound} />
		</StyledContainer>
	);
};

export { MoneyInput };
